<template>
	<div class="container">
		<Navigation-bar>
			<template slot="title">
				<div class="selector_switch-nav" v-if="isFixed" @click="openSelector()">
					<span>筛选</span>
					<YD-image src="icon/icon_下拉箭头_黑色_向下"></YD-image>
				</div>
			</template>
            <template slot="action">
                <YD-image src="icon/icon_search_black" class="search" @click.native="toSearch"></YD-image>
			</template>
		</Navigation-bar>
		<div class="container_content">
			<Scroll :scroll.sync="scrollTop" @scrollEnd="scrollEnd()">
				<Title>
					<template slot="spreadhead">
						<div class="selector_switch" @click="openSelector()">
							<span>筛选</span>
							<YD-image src="icon/icon_下拉箭头_黑色_向下"></YD-image>
						</div>
					</template>
					<template slot="subtitle">
						{{selected.text}}
					</template>
				</Title>
				<div class="data_info">
					<div class="data_info-fixed" :class="{'fixed': isFixed}" :style="dataInfoStyle">
						<div class="selected_text">
							{{selected.text}}
						</div>
						<div class="data_result">
							<div>共<span>{{allCount}}</span>名{{selected.eventsName}}教练员</div>
						</div>
					</div>
				</div>
				<div class="list">
					<div class="list_item" v-for="(item,index) in list" :key="index" v-href="'/RefereeCoach/OccupationDetail/2/' + item.CoachId">
						<div class="item-portrait">
							<img :src="item.PortraitPhoto || getPortraitDefault(item.Gender)" >
						</div>
						<div class="item-body">
							<div class="item-level"><span>{{item.CurrentLevelName}}</span></div>
							<div class="item-name">{{item.Name}}</div>
							<div class="item-location">
								<template v-if="item.AddressInfo.Country == '中国'">
									<template v-if="item.AddressInfo.Region">{{item.AddressInfo.Region.RegionName || ''}}</template>
								</template>
								<template v-else>{{item.AddressInfo.Country || ''}}</template>
							</div>
							<div class="item-eventsName">#{{item.EventsName}}</div>
						</div>
					</div>
				</div>
				<Text-prompt noDataImg="no_data/暂无内容@2x.png" :text="loadMore"></Text-prompt>
			</Scroll>
		</div>
		<selector 
			ref="selector"
			type="coach"
			:form.sync="selectorForm"
			:isFixed="isFixed"
			@search="getDataList(true)"
		></selector>
	</div>
</template>

<script>
	import utils from '@js/utils';
	import selector from './components/selector.vue';
	import {
		GetCoachList
	} from '@/api';
	export default {
		name: "CoachListHome",
		components: {
			selector
		},
		data(){
			return {
				scrollTop: 0,
				selectorForm: {
					eventsId: 0,
					eventsName: "不限",
					level: 0,
					levelName: "不限",
					gender: 0,
					genderName: "不限",
					provinceCode: 0,
					provinceName: "不限"
				},
				allCount: 0,
				list: [],
				loadMore: ""
			}
		},
		created() {
			this.getDataList(true);
		},
		computed:{
			navBarHeight(){
				return utils.getNavBarHeight();
			},
			titleHeight(){
				return utils.getTitleHeightWithInt();
			},
			isFixed(){
				return this.titleHeight < this.scrollTop;
			},
			dataInfoStyle(){
				return this.isFixed ? {
					top: this.navHeight,
					...this.shadow
				} : {}
			},
			shadow(){
				return utils.setScrollShadow(true);
			},
			selected(){
				let form = this.selectorForm;
				let arr = [];
				if(form.eventsId){
					arr.push(form.eventsName);
				}
				if(form.level){
					arr.push(form.levelName);
				}
				if(form.gender){
					arr.push(form.genderName);
				}
				if(form.provinceCode){
					arr.push(form.provinceName);
				}
				return {
					eventsName: form.eventsId != 0 ? form.eventsName : '',
					text: arr.length ? arr.join(' · ') : '项目 · 级别 · 性别 · 地区'
				}
			},
			/// 获取赛事中最后一个Id
			lastId() {
				let length = this.list.length;
				if (length > 0) {
					return this.list[length - 1].CoachId;
				}
				return 0;
			}
		},
		methods:{
			toSearch(){
				this.$navigation.go('/RefereeCoach/CoachSearch');
			},
			openSelector(){
				this.$refs.selector.show();
			},
			scrollEnd(){
				if(!this.loadMore){
					this.getDataList();
				}
			},
			getDataList(isReload = false){
				if(!isReload && this.loadMore == '到底了') return;
				this.loadMore = "加载中";
				let lastId = isReload ? 0 : this.lastId;
				let form = this.selectorForm;
				let param = {
					EventsId: form.eventsId,
					LevelNo: form.level,
					Gender: form.gender,
					ProvinceCode: form.provinceCode,
					Keyword: "",
					Continuation: {
						LastId: lastId,
						MaxCount: 20
					}
				};
				GetCoachList(param).then((data) => {
					if (data.Code === 0) {
						
						this.allCount = data.AllCount;
						let list = data.ContinueList || [];
						if (isReload) {
							this.scrollTop = 0;
							this.list = list;
							if(list.length == 0){
								this.loadMore = "无数据";
							}
						} else {
							this.list.push(...list);
						}
						if (this.list.length < this.allCount) {
							this.loadMore = "";
						} else{
							this.loadMore = "到底了";
						}
					} else {
						this.loadMore = "";
					}
				});
			},
			getPortraitDefault(gender){
				if(gender == 1){
					return require("@/assets/images/referee_coach/list_portrait_default_men@3x.png");
				}else if(gender == 2){
					return require("@/assets/images/referee_coach/list_portrait_default_women@3x.png");
				}else {
					return require("@/assets/images/referee_coach/list_portrait_default@3x.png");
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "./scss/refereeList.scss";
</style>